/* IdentityPoint SOAP Service wrapper */

define('soap/identity',['require','exports','module','jpath/jpath','./common'],function( require, exports, module ) {
    "use strict";

    var serviceName = "IdentityPointService",
        jPath = require("jpath/jpath"),
        commonService = require("./common"),
        svc = new commonService.SOAPService(serviceName, "http://services.bamnetworks.com/registration/identityPoint/");

    /**
     * NOTE: members that represent node attributes must be prefixed with '@'
     *
     * Params object will be serialized directly into a SOAP payload
     * Sample params object:
     * {
     *      identification : {
     *          '@type': 'fingerprint',
     *          id: , // ipid
     *          fingerprint: // fprt
     *      },
     *
     *      subscription : {
     * 			email: "",
     *          optin : {
     *              '@id' : // newsletter id
     *          }
     *			//or
     *			optinGroup: "..."
     *      }
     * }
     *
     * All actions return a Deferred.promise()
     */

    /* Identifies a user
     * Required input arguments:
     * @identification <Object>
     */
    exports.identify = function(params) {
        params = commonService.ensureIdentity(params);
        return svc.callAction("identify", "identityPoint_identify_request", "identityPoint_identify_response", params);
    };

    /* Creates a new user identity
    * Required input arguments:
    * @identification <Object>
    * @email <Object> { id:"", address:"", formatId:0, verified:true }
    * @mobilePhone <Object> { id:"", number:"", carrierId:"", deviceId: "" }
    * @profileProperty <Object> { name: "", value:"", '@createdDate':'2000-01-01', '@modifiedDate':'2001-01-01' }
    * @address <Object> { id:"", description:"", "street1:"", street2:"", city:"", state:"", zipCode:"", country:"",
    firstName:"", lastName:"", middleName:"", phoneNumber:"" phoneType:1(HOME)|2(WORK)|3(MOBILE) }
    * @creditCard <Object> { id:"", description:"", cardType:1(AMEX)|2(VISA)|4(MC)|8(DISCOVER)|16(DINERS),
    number:"", expirationMonth:1, expirtionYear:2000,
    nameOnCard:"", securityId:"", "street1:"", street2:"", city:"", state:"", zipCode:"", country:"",
    firstName:"", lastName:"", middleName:"", phoneNumber:"" phoneType:1(HOME)|2(WORK)|3(MOBILE) }
    */
    exports.create = function(params) {
        params = commonService.ensureIdentity(params);
        commonService.checkRequired(params, "email,mobilePhone,profileProperty,address,creditCard".split(","));
        return svc.callAction("create", "identityPoint_create_request", "identityPoint_create_response", params);
    };

    /* Finds an identity point key
     * Required input arguments:
     * @identification <Object>
     * @keyGroup <String>
     */
    exports.findIdentityPointKeys =function(params) {
        params = commonService.ensureIdentity(params);
        commonService.checkRequired(params, "keyGroup");
        return svc.callAction("findIdentityPointKeys", "identityPoint_findIdentityPointKeys_request", "identityPoint_findIdentityPointKeys_response", params);
    };


    /* Finds modified identity point keys
     * Required input arguments:
     * @fromDate <DateTime>
     * @toDate <DateTime>
     * @findOption <Object> { sortField:"", "@detailLevel":"0", "@startIndex":0, "@endIndex":0, "@sortAsc":true  } (optional)
     */
    exports.findModifiedIdentityPointKeys = function(params) {
        if (!params.fromDate && !params.toDate) {
            throw new Error("fromDate and toDate are required parameters");
        }
        return svc.callAction("findModifiedIdentityPointKeys", "identityPoint_findModifiedIdentityPointKeys_request", "identityPoint_findModifiedIdentityPointKeys_response", params);
    };


    /* Generates an alias
     * Required input arguments:
     * @identification <Object>
     * @secsToExpiration <int>
     * @length <int>
     * @format <String>
     */
    exports.generateAlias = function(params) {
        params = commonService.ensureIdentity(params);
        commonService.checkRequired(params, "secsToExpiration,length,format".split(","));
        return svc.callAction("generateAlias", "identityPoint_generateAlias_request", "identityPoint_generateAlias_response", params);
    };

    /* Saves the name
     * Required input arguments:
     * @identification <Object>
     * @identityPointName <String>
     */
    exports.saveName = function(params) {
        params = commonService.ensureIdentity(params);
        commonService.checkRequired(params, "identityPointName");
        return svc.callAction("saveName", "identityPoint_saveName_request", "identityPoint_saveName_response", params);
    };

    /* Links an identity
     * Required input arguments:
     * @identification <Object>
     * @linkIdentification <Object> (same as identification)
     */
    exports.link =function(params) {
        params = commonService.ensureIdentity(params);
        commonService.checkRequired(params, "linkIdentification");
        return svc.callAction("link", "identityPoint_link_request", "identityPoint_link_response", params);
    };

    /* UnLinks an identity
     * Required input arguments:
     * @identification <Object>
     */
    exports.unlink =function(params) {
        params = commonService.ensureIdentity(params);
        return svc.callAction("unlink", "identityPoint_unlink_request", "identityPoint_unlink_response", params);
    };

    /* Saves enabled flag
     * Required input arguments:
     * @identification <Object>
     * @flag <String>
     */
    exports.saveEnabledFlag = function(params) {
        params = commonService.ensureIdentity(params);
        commonService.checkRequired(params, "flag");
        return svc.callAction("saveEnabledFlag", "identityPoint_saveEnabledFlag_request", "identityPoint_saveEnabledFlag_response", params);
    }

});
